/* eslint-disable import/no-anonymous-default-export */
export default {
  // service : 'https://www.bookwedgo.com/api'
  // service : 'https://api.bookwedgo.com/api'
  service: "https://apiprod.bookwedgo.com/api",
  // service : 'http://127.0.0.1:8000/api'
};
